import { NgModule } from "@angular/core";
import { UserCombiFromToComponent } from "./usercombi-from-to.component";

@NgModule({
  declarations: [
    UserCombiFromToComponent,
  ],
  exports: [UserCombiFromToComponent]
})
export class UserCombiFromToModule {
}
